var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Card Box Bank (" + _vm._s(this.rules.name) + ")"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard, title: "Guard Config" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-guard-money-panel", {
                    attrs: {
                      model: _vm.model.guardMoney,
                      title: "Guard Money",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guardMoney", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        attrs: { model: _vm.model.currency },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "currency", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("r-product-dropdown", {
                        attrs: { model: _vm.model.product, label: "Product" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "product", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.reward,
                          title: "Rewards",
                          label: "Reward",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }